import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

const KEY = "nv_recently_viewed";
const MAX = 8;

/** Track that this product was viewed (call from Product page). */
export function trackView(product) {
  if (!product?.id) return;
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    const dedup = [product.id, ...list.filter((id) => id !== product.id)].slice(0, MAX);
    localStorage.setItem(KEY, JSON.stringify(dedup));
  } catch {}
}

/** Recently viewed carousel. `excludeId` skips the product currently being viewed. */
export default function RecentlyViewed({ excludeId }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(KEY);
      const ids = raw ? JSON.parse(raw) : [];
      const wanted = ids.filter((id) => id !== excludeId);
      if (!wanted.length) { setItems([]); return; }
      // Fetch each product (endpoint accepts id or slug)
      Promise.all(wanted.map((id) => api.get(`/products/${id}`).then((r) => r.data.product).catch(() => null)))
        .then((rows) => setItems(rows.filter(Boolean).slice(0, 4)));
    } catch {}
  }, [excludeId]);

  if (!items.length) return null;

  return (
    <section className="mt-8 border-t border-[#E7E5E4] pt-7" data-testid="recently-viewed">
      <div className="mb-4">
        <div className="text-xs uppercase tracking-[0.2em] text-[#7C1F30] mb-1">Continue browsing</div>
        <h2 className="font-serif text-xl sm:text-2xl text-[#173A3A]">Recently viewed</h2>
      </div>
      <div className="grid grid-cols-2 gap-x-2 gap-y-4 sm:gap-x-3 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
        {items.map((p) => <ProductCard key={p.id} product={p} />)}
      </div>
    </section>
  );
}
